module.exports = __webpack_public_path__ + "img/main_home1.e3d8c0e.png";